/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class OutputOrderModel {

        public workflowBlock: IWorkflowBlock;
        public isReadonly: boolean;
        public dto: Wars.Domain.Model.Dtos.Workflow.WorkflowBlockOutputOrderDto;
    }
}